import { images } from "../constants";

const testimonials = [  
  {
    id: 1,
    image: images.testimonial1,
    name: "Anna & Mark Johnson",
    title: "Wedding Couple",
    content: "We couldn't have asked for a more perfect wedding day. The planning team handled everything with such grace and professionalism. From the venue selection to the floral arrangements, every detail was flawless!"
  },
  {
    id: 2,
    image: images.testimonial2,
    name: "Jessica & Ryan Lee",
    title: "Wedding Couple",
    content: "Our wedding planner made the whole process so enjoyable and stress-free. They took care of everything, allowing us to truly enjoy our special day. The food catering and décor were beyond our expectations!"
  },
  {
    id: 3,
    image: images.testimonial3,
    name: "Emily & David Martinez",
    title: "Wedding Couple",
    content: "The team at Eternal Vows was incredible! From the first meeting to the big day, they ensured every detail was perfect. Our guests raved about the food, and the entertainment made our night unforgettable."
  },
  {
    id: 4,
    image: images.testimonial4,
    name: "Sophie & Michael Brown",
    title: "Wedding Couple",
    content: "Our wedding day was a dream come true, thanks to the amazing team at Eternal Vows. They went above and beyond to ensure that everything was perfect. We will be forever grateful!"
  },
];

export default testimonials;